/* src/app/get-client-shipping-info/get-client-shipping-info.component.scss */
.general-container {
  max-width: 1000px;
  width: 90%;
  min-width: 45%;
}
.shipping-info-form-container {
  display: flex;
  padding: 30px;
  flex-direction: column;
  align-items: flex-end;
  gap: 30px;
  align-self: stretch;
  border-radius: 30px;
  background: #fff;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.15);
}
.shipping-info-form-container .header-section {
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 15px;
  align-self: stretch;
  border-radius: 20px;
  background: #f6f6f6;
  gap: 15px;
}
.shipping-info-form-container .header-section h2 {
  color: black;
  font-family: "Raleway", sans-serif;
  font-size: 32px;
  font-weight: 600;
  letter-spacing: -0.64px;
}
.shipping-info-form-container .header-section span {
  color: black;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.32px;
}
.form-group {
  margin-bottom: 1.5rem;
}
.form-group label {
  color: black;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 10px;
  display: flex;
}
.form-group input {
  width: 100%;
  height: 48px;
  display: flex;
  padding: 16px 10px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid #949494;
  background: #fff;
  transition: border-color 0.3s ease;
}
.form-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.2);
}
ion-button {
  float: right;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 20px;
  color: #fff;
  border-radius: 15px;
}
ion-button::part(native) {
  height: 3rem;
  width: 8rem;
  min-height: unset;
  padding: 14px 18px !important;
}
.error {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 18px;
  color: #e74c3c;
  margin-top: 0.25rem;
  display: block;
}
.progress-wrapper {
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #cbcbcb;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);
}
/*# sourceMappingURL=get-client-shipping-info.component-ONTL46ZG.css.map */
